<style scoped >
.metric { min-height: 115px;}
</style>
<template>
<v-card>
  <v-card-title class='headline' >
    {{ $t('title') }}
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text v-if='me' >
    <blockquote class='blockquote pl-0 pt-0' >{{ $t('subtitle') }}
    </blockquote>
    <h4 class='overline' >{{ $t('link.overline') }}</h4>

    <v-text-field
      append-icon='file_copy'
      :value='referralLink'
      @click:append='copyToClipboard'
      :hint='copyLinkText'
      :persistent-hint='true'
      box >
    </v-text-field>
    <v-progress-linear v-if='loadingFunnel' :height='2' indeterminate >
    </v-progress-linear>
    <template v-if='funnel' >
      <h4 class='overline mt-4' >{{ $t('stats.title') }}</h4>
      <v-layout >
        <v-flex xs4 >
          <v-card class='metric'>
            <v-card-title class='overline' >
              {{ $t('subtitles.referred') }}
            </v-card-title>
            <v-card-text class='headline'>
              {{ funnel.total }}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs4 >
          <v-card class='metric'>
            <v-card-title class='overline' >
              {{ $t('subtitles.ontrial') }}
            </v-card-title>
            <v-card-text class='headline'>
              {{ funnel.referred }}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs4 >
          <v-card class='metric'>
            <v-card-title class='overline' >
              {{ $t('subtitles.converted') }}
            </v-card-title>
            <v-card-text class='headline' >
              {{ funnel.converted }}
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs4 >
          <v-card class='metric'>
            <v-card-title class='subtitle-1 overline' >
              {{ $t('subtitles.creditbalance') }}
              <v-spacer></v-spacer>
              <help-popover small >
                {{ $t('credits.helptext') }}
              </help-popover>
            </v-card-title>
            <v-card-text class='headline' >
              {{ formatnumber(credits.available, true) }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </v-card-text>
</v-card>
</template>
<script>
import axios from 'axios'
import HelpPopover from '@/components/ui/HelpPopover'

export default {
  name: 'EarnPage',
  components: {HelpPopover},
  data () {
    return {
      freeDays: 31,
      defaultCopyLinkText: this.$t('subtitle'),
      copyLinkText: '',
      funnel: null,
      loadingFunnel: false
      // funnel: {
      //   total: 3,
      //   referred: 2,
      //   converted: 1,
      //   since: {
      //     since: '2020-01-16',
      //     total: 3,
      //     referred: 2,
      //     converted: 1
      //   }
      // }
    }
  },
  mounted () {
    this.copyLinkText = this.defaultCopyLinkText
    this.getFunnel()
  },
  computed: {
    referralLink () {
      return `http://appointmentguru.co/?utm_campaign=${this.me.profile.referral_key}&utm_medium=referral`
    },
    me () {
      return this.$store.getters.me
    },
    credits () {
      let earned = parseFloat(this.getObjectPath(this.me, 'profile.credits_earned', 0))
      let used = parseFloat(this.getObjectPath(this.me, 'profile.credits_used', 0))
      let available = parseFloat(earned - used)
      return {earned, used, available}
    }
  },
  methods: {
    async getFunnel () {
      this.loadingFunnel = true
      let url = `${this.$appointmentguru.baseUrl}/api/practitioners/${this.$store.getters.me.id}/campaign_funnel/?since=2020-01-01`
      let options = {
        url,
        headers: this.$appointmentguru.headers,
        method: 'get'
      }
      let res = await axios(options)
      if (res.status === 200) {
        this.funnel = res.data
        this.loadingFunnel = false
      } else {
        this.loadingFunnel = false
      }
    },
    copyToClipboard () {
      const el = document.createElement('textarea')
      el.value = this.referralLink
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copyLinkText = 'Copied to clipboard'
      window.setTimeout(() => {
        this.copyLinkText = this.defaultCopyLinkText
      }, 4000)
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Refer a friend',
        subtitle: 'Get R300 credited to your AppointmentGuru account each time someone you referred becomes a paying AppointmentGuru customer',
        link: {
          overline: 'Your referral link'
        },
        subtitles: {
          referred: 'Referred',
          ontrial: 'On trial',
          converted: 'Upgraded',
          creditbalance: 'Your credit balance'
        },
        credits: {
          helptext: 'Credits will be applied to your account whenever someone you have referred becomes a paying AppointmentGuru customer. Credit will be used automatically on your next billing cycle. The number below is the outstanding credit due to you.'
        },
        stats: {
          title: 'Referral Stats'
        }
      },
      es: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// Earn.vue?2a1924a9